<template>
  <div>
    <LoadingAnimation full-page v-if="loading" />
    <TemplateModal
      ref="modal"
      center
      empty width="650" :sendFunction="onCreateReport" :key="key" :text="{title: {create: localStorage.translations.pages.common.buttons.confirm}}">
      <template v-slot:activator>
        <v-btn
          @click="openModal"
          :width="size"
          :height="size"
          :elevation="0" fab
        >
          <v-icon :size="$vuetify.breakpoint.smAndDown ? 25 : 35">mdi-check</v-icon>
        </v-btn>
      </template>
      <div class="container_btn d-flex justify-space-around">
        <v-hover v-slot="{ hover }">
          <v-btn
            @click="closeModal"
            :width="size"
            :height="size"
            :elevation="0"
            fab dark :outlined="!hover"
            color="red"
          >
            <v-icon :size="$vuetify.breakpoint.smAndDown ? 25 : 35">mdi-close</v-icon>
          </v-btn>
        </v-hover>
        <v-hover v-slot="{ hover }">
          <v-btn
            type="submit"
            :width="size"
            :height="size"
            :elevation="0"
            fab dark :outlined="!hover"
            color="#277FAF"
          >
            <v-icon :size="$vuetify.breakpoint.smAndDown ? 25 : 35">mdi-check</v-icon>
          </v-btn>
        </v-hover>
      </div>
    </TemplateModal>
  </div>
</template>

<script>
import LoadingAnimation from "components/LoadingAnimation";
import TemplateModal from "components/templates/TemplateModal";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "StatisticProjectReportsApproveModal",
  components: {TemplateModal, LoadingAnimation},
  props: {
    size: {
      type: [Number, String, Function],
    },
    works: {
      type: Object,
      default: () => {
        return {
          work_types: [],
          extras: []
        }
      }
    },
    reportStatusMap: {
      type: Object,
      default: () => {
        return {
          work_types: {},
          extras: {}
        }
      }
    },
    notes: Boolean,
  },
  data: () => ({
    loading: false,
    key: 0,
  }),
  computed: {
    ...mapGetters('workClientProjectsClientReports', ['workClientProjectsClientReportsGeneralNote'])
  },
  methods: {
    ...mapActions('workClientProjectsClientReports', [
      'onWorkClientProjectsClientReportsBillCreate',
      'onWorkClientProjectsClientReportsBillApprove',
      'onWorkClientProjectsClientReportsBillUpdate',
      'onWorkClientProjectsClientReportsBillGrid'
    ]),
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    async onCreateReport() {
      let billId = await this.resolveBillId()
      if (!billId) {
        this.loading = false
        this.$store.dispatch(
          'popup/onMessage',
          {message: this.localStorage.translations.pages.common.notifications['oshibka'], IsError: true},
          {root: true}
        )
        return
      }
      await this.onWorkClientProjectsClientReportsBillUpdate({
        id: billId,
        data: this.buildBillData(billId)
      })
        .then(() => {
          this.onApproveReport(billId)
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.localStorage.translations.pages.common.notifications['oshibka'], IsError: true},
            {root: true}
          )
        })
    },
    async onApproveReport(id) {
      this.onWorkClientProjectsClientReportsBillApprove({id})
        .then(() => {
          this.$router.push({name: 'timeControlShowReportsViewBill', params: {bill: id}})
        })
    },
    buildBillData(billId = null) {
      let reportId = this.$route.params.report_id
      const filterIdsForBill = (ids, type) => {
        const isEmptyBillId = (value) => {
          return value === null || value === undefined || value === '' || value === 'null'
        }
        const isSameBillId = (value, currentBillId) => {
          if (isEmptyBillId(value) || isEmptyBillId(currentBillId)) return false
          return String(value) === String(currentBillId)
        }
        let map = this?.reportStatusMap?.[type] || {}
        return Object.assign([], ids).filter((id) => {
          let status = map?.[id]?.status
          let clientBillId = map?.[id]?.client_bill_id
          return (status !== 'signed' && status !== 'approved')
            && (isEmptyBillId(clientBillId) || isSameBillId(clientBillId, billId))
        })
      }
      return {
        period_report_id: reportId,
        employee_reports: filterIdsForBill(this.works.work_types, 'work_types'),
        work_extras: filterIdsForBill(this.works.extras, 'extras'),
        report_with_employee_notes: this.notes ? 1 : 0,
        general_note: this?.workClientProjectsClientReportsGeneralNote[reportId]?.reportGeneralNote || '',
      }
    },
    async resolveBillId() {
      let reportId = this.$route.params.report_id
      if (!reportId) {
        return null
      }
      let billId = null
      await this.onWorkClientProjectsClientReportsBillGrid({report: reportId})
        .then((res) => {
          let bills = res?.data?.data || []
          if (bills.length > 0) {
            let sorted = Object.assign([], bills).sort((a, b) => Number(b.id) - Number(a.id))
            billId = sorted[0]?.id || null
          }
        })
        .catch(() => {})
      if (billId) {
        return billId
      }
      return this.onWorkClientProjectsClientReportsBillCreate({data: this.buildBillData()})
        .then((res) => {
          return res.data.data.id
        })
        .catch(() => null)
    }
  }
}
</script>

<style scoped lang="scss">
.container_btn {
  width: 100%;
  margin-top: 30px;
}
</style>
